@if ((isCollectionAdmin$ | async)) {
  <button class="dropdown-item"
    [innerHTML]="'context-menu.actions.export-item.btn' | translate"
    (click)="$event.preventDefault();exportCollection();">
  </button>
}
